<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <croptype-form :itemId="id" formType="Edit" subTitle="Edit Crop Type"></croptype-form>
      </div>
    </div>
  </div>
</template>

<script>
import CroptypeForm from "@/views/croptype/components/Form.vue";

export default {
  name: "edit-croptype",
  data(){
    return {
      id : this.$route.params.id
    }
  },
  components: {
    CroptypeForm,
  }
};
</script>